import { useDidUpdate } from "app/custom-hooks/useDidUpdate";
import type { TranslationReplacements } from "app/filters/i18nFilter";
import { translate } from "app/filters/i18nFilter";
import { StyledButton } from "./styles";
import type { Translatable } from "app/pages/sales-intelligence/types";
import { useState } from "react";

type FiltersViewSubmitButtonProps = {
    className?: string;
    isDisabled?: boolean;
    isSubmitInProgress: boolean;
    text: Readonly<Translatable>;
    onClick(): void;
};

const FiltersViewSubmitButton = (props: FiltersViewSubmitButtonProps) => {
    const { className, isDisabled = false, isSubmitInProgress, text, onClick } = props;
    const [isLoading, setIsLoading] = useState(false);

    useDidUpdate(() => {
        setIsLoading(isSubmitInProgress);
    }, [isSubmitInProgress]);

    function handleClick() {
        if (!isLoading) {
            setIsLoading(true);
            onClick();
        }
    }

    return (
        <StyledButton
            className={className}
            dataAutomation="filters-view-submit-button"
            isDisabled={isDisabled || isLoading}
            isLoading={isLoading}
            type="primary"
            onClick={handleClick}
        >
            {translate(text.key, text.replacements as TranslationReplacements)}
        </StyledButton>
    );
}

export default FiltersViewSubmitButton;
